<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableCenDate"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="detail">
        <Button
          type="info"
          size="small"
          v-hasPermission="['network:cenMonitor:queryCenByCenId']"
          @click="rowClick(row)"
          >{{ $t("alarms.common.details") }}</Button
        >
      </template>
    </Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableCenVue = {};
export default {
  name: "TableCen",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      region: "",
      columns: [
        {
          title: this.$t("alarms.network.cen.name"),
          key: "name"
        },
        {
          title: this.$t("alarms.common.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("alarms.common.accountType"),
          key: "accountTypeName"
        },
        {
          title: this.$t("alarms.network.cen.cenId"),
          key: "cenId"
        },
        {
          title: this.$t("alarms.network.cen.description"),
          key: "description"
        },
        {
          title: this.$t("alarms.network.loadBalancing.region"),
          key: "region"
        },
        {
          title: this.$t("common.operation"),
          slot: "detail"
        }
      ],
      tableCenDate: []
    };
  },
  beforeCreate: function() {
    tableCenVue = this;
  },
  created() {
    eventBus.$on("companyId", function(val) {
      tableCenVue.companyId = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableCenVue.getCenData();
    },
    // 分页显示数据
    /****************************************************/
    getCenData: function() {
      //列表分页
      this.$api.cen
        .pageCen({
          pageNum: this.current,
          pageSize: this.pageSize,
          monitorModule: 18,
          companyId: tableCenVue.companyId
        })
        .then(res => {
          this.tableCenDate = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableCenVue.getCenData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableCenVue.getCenData();
    },
    // 销毁regionName
    beforeDestroy: function() {
      eventBus.$off("regionName");
    },
    // 单击行
    /****************************************************/
    rowClick: function(row) {
      this.$router.push({
        path: "/network/cenDetail/",
        query: {
          id: row.id,
          accountId: row.accountId,
          cenId: row.cenId,
          region: row.region,
          accountTypeName: row.accountTypeName,
          accountName: row.accountName,
          name: row.name
        }
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/network/cen/TableCen.vue